import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { NavigationService } from "src/app/service/navigation.service";
import { QuoteService } from "src/app/service/quote.service";


@Component({
  selector: "app-home",
  templateUrl: "home.component.html",
  styleUrls: ["home.component.css"],
})
export class HomeComponent implements OnInit {
  @ViewChild('heroVideo') heroVideo?: ElementRef<HTMLVideoElement>;
  /** Video del hero según el ancho de pantalla (mismos cortes que el banner anterior) */
  heroVideoSrc = HomeComponent.pickHeroVideo(typeof window !== 'undefined' ? window.innerWidth : 1440);
  /** Poster solo en >=768: en movil el video es vertical (Mobile.mp4) y el poster de escritorio saltaba al arrancar; el fondo gris #d9d3d2 ya iguala al video */
  heroPoster: string | null = HomeComponent.pickHeroPoster(typeof window !== 'undefined' ? window.innerWidth : 1440);
  private observer!: IntersectionObserver;
  scrollY = 0;
  mobileImageOffset = 0;

  screenWidth: number;
  windowWidth: number;
  
  showCover: boolean = false;
  /** Sección "Protección integral": pestaña activa y grupos desplegados */
  benefitTab: 'medica' | 'viajero' = 'medica';
  benefitOpen: { [key: string]: boolean } = (typeof window !== 'undefined' && window.innerWidth < 768) ? {} : { viaje: true }; // escritorio: 'Beneficios durante el viaje' abierto; movil: todo cerrado
  /** Carrusel de Asistencia Médica (3 + 3): página activa y rotación automática */
  benefitPage = 0;
  benefFading = false;
  /** Beneficios por pagina: 3 en escritorio, 2 en movil (<768) */
  benefPageSize = (typeof window !== 'undefined' && window.innerWidth < 768) ? 2 : 3;
  get benefPageList(): number[] { return Array.from({ length: Math.ceil(6 / this.benefPageSize) }, (_, i) => i); }
  benefOn(i: number): boolean { return Math.floor(i / this.benefPageSize) === this.benefitPage; }
  benefLast(i: number): boolean { return this.benefOn(i) && (i % this.benefPageSize === this.benefPageSize - 1 || i === 5); }
  private onBenefResize = () => {
    const s = window.innerWidth < 768 ? 2 : 3;
    if (s !== this.benefPageSize) { this.benefPageSize = s; this.benefitPage = 0; }
  };
  private benefitAuto = true;
  private benefitTimer: any = null;
  private readonly benefitIntervalMs = 6000;
  showCoverTwo: boolean = false;
  

  isMobileImageVisible = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.requestSkyParallax();
    const currentY = window.scrollY;
    const direction = currentY - this.scrollY;

    const mobileImage = document.querySelector('.proteccion-left-section img') as HTMLElement;
    if (this.isMobileImageVisible && mobileImage) {
      this.mobileImageOffset += direction > 0 ? -1 : 1;

      this.mobileImageOffset = Math.max(-30, Math.min(30, this.mobileImageOffset));

      mobileImage.style.transform = `translateY(${this.mobileImageOffset}px)`;
    }

    this.scrollY = currentY;
  }

  /** Poster = primer fotograma del propio video (hero-poster-*.jpg), asi el encuadre coincide y no hay salto al arrancar.
   *  hero-1x.jpg (exportacion del Figma) tenia otro encuadre: el telefono se veia enorme y desplazado mientras cargaba. */
  static pickHeroPoster(width: number): string | null {
    if (width < 768) return null;            // Mobile.mp4 es vertical; el fondo #d9d3d2 iguala al video
    if (width < 1200) return '/assets/img/hero/hero-poster-fhd.jpg';   // FHD 2500x1500
    return '/assets/img/hero/hero-poster-qhd.jpg';                      // QHD / 4k / 5k (16:9)
  }

  static pickHeroVideo(width: number): string {
    if (width >= 2500) return '/assets/img/5k.mp4';
    if (width >= 1920) return '/assets/img/4k.mp4';
    if (width >= 1200) return '/assets/img/QHD.mp4';
    if (width >= 768) return '/assets/img/FHD.mp4';
    return '/assets/img/Mobile.mp4';
  }

  /** Sección "4 datos": el cielo se desplaza suavemente con el scroll (parallax) */
  private skyTicking = false;
  private requestSkyParallax() {
    if (this.skyTicking) return;
    this.skyTicking = true;
    requestAnimationFrame(() => { this.skyTicking = false; this.updateSkyParallax(); });
  }
  private updateSkyParallax() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const sec = document.querySelector('.facts-sec') as HTMLElement;
    if (!sec) return;
    const r = sec.getBoundingClientRect();
    const vh = window.innerHeight || 1;
    // -1 (entrando por abajo) ... 0 (centrada) ... 1 (saliendo por arriba)
    const p = Math.max(-1, Math.min(1, (vh / 2 - (r.top + r.height / 2)) / vh));
    sec.style.setProperty('--sky', (p * 40).toFixed(1) + 'px');
  }

  ngAfterViewInit() {
    this.requestSkyParallax();
    this.startBenefitRotation();
    window.addEventListener('resize', this.onBenefResize);
    const video = this.heroVideo?.nativeElement;
    if (video) {
      video.muted = true;
      video.play().catch(() => { /* autoplay bloqueado: queda el poster */ });
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const logo = entry.target.querySelector('.big-logo');
          const lady = entry.target.querySelector('.beneficios-lady');
          const fourBoxSection = entry.target.querySelector('.fourBoxSection');
          const beneficiosContainer = entry.target.querySelector('.beneficios-container');
          const proteccionContainer = entry.target.querySelector('.proteccion-container');

          if (logo) logo.classList.add('animate');
          if (lady) lady.classList.add('animate');
          if (fourBoxSection) fourBoxSection.classList.add('animate');
          if (beneficiosContainer) beneficiosContainer.classList.add('animate');
          if (proteccionContainer) {proteccionContainer.classList.add('animate');this.isMobileImageVisible = true}
          if (entry.target.classList.contains('facts-sec')) { entry.target.classList.add('in'); this.runFactsCount(entry.target as HTMLElement); }

          this.observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    // Observe sections
    const sections = document.querySelectorAll('.beneficios-blue-assist, .beneficios-lady-container, .facts-sec, .proteccion-section');
    sections.forEach(section => this.observer.observe(section));

    // Reveal al hacer scroll: cada grupo .rv-grp entra una sola vez; sus .rv / .rv-up se escalonan en orden visible (--i)
    // Elementos que al entrar el grupo siguen bajo el borde inferior (grupos altos en movil): se revelan uno a uno al asomar
    const soloObs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target as HTMLElement;
        el.style.setProperty('--i', '0');
        el.classList.add('is-in');
        soloObs.unobserve(el);
      });
    }, { threshold: 0.3 });
    const rvObs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const grp = entry.target as HTMLElement;
        const limit = window.innerHeight - 24;
        let i = 0;
        grp.querySelectorAll<HTMLElement>('.rv, .rv-up').forEach(el => {
          const visible = el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
          // Solo los bloques .rv: las lineas .rv-up viven dentro de una mascara (overflow:hidden) y el observador nunca las veria entrar
          if (visible && !el.classList.contains('rv-up') && el.getBoundingClientRect().top > limit) {
            el.classList.add('rv-solo');
            soloObs.observe(el);
            return;
          }
          el.style.setProperty('--i', String(visible ? i++ : 0));
        });
        grp.classList.add('is-in');
        rvObs.unobserve(grp);
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.rv-grp').forEach(g => rvObs.observe(g));
  }

  /** Sección "4 datos": las cifras cuentan hasta su valor al entrar en pantalla */
  private runFactsCount(section: HTMLElement) {
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    section.querySelectorAll<HTMLElement>('[data-count]').forEach(el => {
      const end = parseInt(el.dataset['count'] || '0', 10);
      if (reduce || !end) { el.textContent = String(end); return; }
      const item = el.closest<HTMLElement>('.facts-r');
      const delay = item ? (parseFloat(getComputedStyle(item).getPropertyValue('--d')) * 1000 || 0) : 0;
      el.textContent = '0';
      setTimeout(() => {
        const t0 = performance.now(), dur = 1100;
        const step = (now: number) => {
          let k = Math.min(1, (now - t0) / dur); k = 1 - Math.pow(1 - k, 3);
          el.textContent = String(Math.round(end * k));
          if (k < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }, delay);
    });
  }

  ngOnDestroy() {
    this.pauseBenefitRotation();
    window.removeEventListener('resize', this.onBenefResize);
    if (this.observer) {
      this.observer.disconnect(); // Prevent memory leaks
    }
  }
  

  constructor(
    private cdr: ChangeDetectorRef, 
    private quoteService: QuoteService,
    private navigate: NavigationService
  ) {
    this.getScreenSize();
  }

  ngOnInit(): void {
    
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    setTimeout(() => {
      this.screenWidth = screen.width;
      this.cdr.detectChanges(); // Detect changes manually
    });
  }

  goQuote() {
		this.navigate.navigateToQuote()
	}

  setBenefitTab(tab: 'medica' | 'viajero') {
    this.benefitTab = tab;
  }
  toggleBenefit(key: string) {
    const wasOpen = !!this.benefitOpen[key];
    this.benefitOpen = wasOpen ? {} : { [key]: true }; // acordeón: nunca dos grupos abiertos a la vez
    this.stopBenefitRotation(); // si abre un grupo, no se lo cambiamos de página
  }
  goBenefitPage(page: number, manual = false) {
    const n = this.benefPageList.length;
    const next = ((page % n) + n) % n;
    if (manual) this.stopBenefitRotation();
    if (next === this.benefitPage) return;
    this.benefFading = true;
    setTimeout(() => { this.benefitPage = next; this.benefFading = false; }, 180);
  }
  startBenefitRotation() {
    if (!this.benefitAuto || this.benefitTimer) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.benefitTimer = setInterval(() => {
      if (this.benefitTab === 'medica') this.goBenefitPage(this.benefitPage + 1);
    }, this.benefitIntervalMs);
  }
  pauseBenefitRotation() {
    if (this.benefitTimer) { clearInterval(this.benefitTimer); this.benefitTimer = null; }
  }
  resumeBenefitRotation() {
    this.startBenefitRotation();
  }
  stopBenefitRotation() {
    this.benefitAuto = false;
    this.pauseBenefitRotation();
  }

  showCobertura() {
    this.showCover = !this.showCover;
  }
  showCoberturaTwo() {
    this.showCoverTwo = !this.showCoverTwo;
  }


  goBenefit(){
    this.navigate.navigateToBenefits()
  }

  scrollTo(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      const headerOffset = 0; // Adjust this value to match your fixed header height
      
      if (element) {
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerOffset;
      
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    }
  }
}
